import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs/Observable"; 
import { AppCommonService } from "../appcommon.service";
import { AuthService } from "../auth.service";
import { GlobalService } from "../global.service";
import { Router } from "@angular/router";
import { ApiEndPoints } from "../api.endpoints";
import { forEach } from "@angular/router/src/utils/collection";
import { UnusualMile, UninvoicedDrawing, CardMisusage, AutomatedDrawing, UnusualMileReportModel, UninvoicedDrawingReportModel, CardMisusageReportModel, AutomatedDrawingReportModel } from "./reports";

@Injectable()
export class ReportsService extends GlobalService {
  constructor(
    private http: Http,
    private cookieService: CookieService,
    private appCommonService: AppCommonService,
    private authService: AuthService,
    private router: Router
  ) {
    super(http, router);
    this.authServiceRef = this.authService;
  }

  getUnusualMileageByAccountId(id: string): Observable<UnusualMile> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UnusualMilesEndPoint.replace('{accountId}', id);
      return this.http.get(url, options)
        .map(this.extractData)
        // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
      let model = new UnusualMileReportModel();
      //model.EndPointURL = ApiEndPoints.UnusualMilesEndPoint;
      model.AccountId = id;
      model.Token = token.access_token;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UnusualMilesEndPointServer;

      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  saveUnusualMileage(unusualMile: UnusualMile, id: string): Observable<UnusualMile> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UnusualMilesEndPoint.replace('{accountId}', id);
      return this.http.put(url, unusualMile, options)
        // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
      let model = new UnusualMileReportModel();
      //model.EndPointURL = ApiEndPoints.UnusualMilesEndPoint;
      model.Token = token.access_token;
      model.UnusualMile = unusualMile;
      model.AccountId = id;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UnusualMilesEndPointSaveServer;
      return this.http.put(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  getUninvoicedDrawingByAccountId(id: string): Observable<UninvoicedDrawing> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UninvoicedDrawingsPoint.replace('{accountId}', id);
      return this.http.get(url, options)
        .map(this.extractData)
        // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      let token = this.authService.getToken();
      let model = new UninvoicedDrawingReportModel();
      //model.EndPointURL = ApiEndPoints.UninvoicedDrawingsPoint;
      model.AccountId = id;
      model.Token = token.access_token;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UninvoicedDrawingsPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  saveUninvoicedDrawing(uninvoicedDrawing: UninvoicedDrawing, id: string): Observable<UninvoicedDrawing> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.UninvoicedDrawingsPoint.replace('{accountId}', id);
      return this.http.put(url, uninvoicedDrawing, options)
        // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    }
    else {
      //debugger;
      let token = this.authService.getToken();
      let model = new UninvoicedDrawingReportModel();
      //model.EndPointURL = ApiEndPoints.UninvoicedDrawingsPoint;
      model.Token = token.access_token;
      model.UninvoicedDrawing = uninvoicedDrawing;
      model.AccountId = id;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UninvoicedDrawingsPointSaveServer;
      return this.http.put(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  LoadDrawingReportUsersByUserId(id: string): Observable<any> {

    let headers = this.authService.GetAuthHeaderNew();
    let options = new RequestOptions({ headers: headers });
    const url = ApiEndPoints.LoadDrawingReportUsersByUserId.replace('{id}', id);
    return this.http.get(url, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);

  }

  DeleteRegisteredUser(id: string): Observable<any> {

    let headers = this.authService.GetAuthHeaderNew();
    let options = new RequestOptions({ headers: headers });
    const url = ApiEndPoints.DeleteRegisterCompanyUserPoint.replace('{id}', id);
    return this.http.delete(url, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);

  }

  LoadDrawingReportCompanyUsers(id: string): Observable<any> {

    let headers = this.authService.GetAuthHeaderNew();
    let options = new RequestOptions({ headers: headers });
    const url = ApiEndPoints.LoadDrawingReportUsers.replace('{companyAcId}', id);
    return this.http.get(url, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);

  }


  LoadDrawingReportCompanyByAcId(id: string): Observable<any> {

    let headers = this.authService.GetAuthHeaderNew();
    let options = new RequestOptions({ headers: headers });
    const url = ApiEndPoints.LoadDrawingReportCompanyByAcId.replace('{acid}', id);
    return this.http.get(url, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);

  }

  LoadDrawingReportCompany(): Observable<any> {

    let headers = this.authService.GetAuthHeaderNew();
    let options = new RequestOptions({ headers: headers });
    const url = ApiEndPoints.LoadDrawingReportCompany;
    return this.http.get(url, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);

  }

  unRegisterCompany(id: string): Observable<any> {
    let headers = this.authService.GetAuthHeaderNew();
    let options = new RequestOptions({ headers: headers });
    const url = ApiEndPoints.UnRegisterCompanyPoint.replace('{acid}', id);
    return this.http.post(url, null, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);

  }

  unRegisterCompanyUser(companyUser: any): Observable<any> {
    let headers = this.authService.GetAuthHeaderNew();
    let options = new RequestOptions({ headers: headers });
    let body = JSON.stringify(companyUser);
    const url = ApiEndPoints.UnRegisterCompanyUserPoint.replace('{acid}', companyUser.AcId).replace('{email}', companyUser.Email);
    return this.http.post(url, null, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);

  }


  saveUninvoicedDrawingRegisterCompany(uninvoicedDrawing: any, id: string): Observable<any> {    
    let headers = this.authService.GetAuthHeaderNew();
    let options = new RequestOptions({ headers: headers });
    let body = JSON.stringify(uninvoicedDrawing);
    const url = ApiEndPoints.UninvoicedDrawingsRegisterCompanyPoint.replace('{acid}', id);
    return this.http.post(url, body, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);
  }

  saveUninvoicedDrawingRegisterCompanyUser(companyUser: any): Observable<any> {    
    let headers = this.authService.GetAuthHeaderNew();
    let options = new RequestOptions({ headers: headers });
    let body = JSON.stringify(companyUser);
    const url = ApiEndPoints.UninvoicedDrawingsRegisterCompanyUserPoint;
    return this.http.post(url, body, options)
      // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
      .catch(this.handleError);
  }



  getCardMisusageByAccountId(id: string): Observable<CardMisusage> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.CardMisusageEndPoint.replace('{accountId}', id);
      return this.http.get(url, options)
        .map(this.extractData)
        // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
        .catch(this.handleError);
    } else {
      let token = this.authService.getToken();
      let model = new CardMisusageReportModel();
      //model.EndPointURL = ApiEndPoints.CardMisusageEndPoint;
      model.AccountId = id;
      model.Token = token.access_token;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CardMisusageEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  saveCardMisusage(cardMisusage: CardMisusage, id: string): Observable<CardMisusage> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.CardMisusageEndPoint.replace('{accountId}', id);
      return this.http.put(url, cardMisusage, options)
        // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    } else {
      let token = this.authService.getToken();
      let model = new CardMisusageReportModel();
      //model.EndPointURL = ApiEndPoints.CardMisusageEndPoint;
      model.Token = token.access_token;
      model.CardMisusage = cardMisusage;
      model.AccountId = id;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CardMisusageEndPointSaveServer;
      return this.http.put(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  getAutomatedDrawingByAccountId(id: string): Observable<AutomatedDrawing> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.AutomatedDrawingsEndPoint.replace('{accountId}', id);
      return this.http.get(url, options)
        .map(this.extractData)
        // .do(data => console.log('getProduct: ' + JSON.stringify(data)))
        .catch(this.handleError);
    } else {
      let token = this.authService.getToken();
      let model = new AutomatedDrawingReportModel();
      //model.EndPointURL = ApiEndPoints.AutomatedDrawingsEndPoint;
      model.AccountId = id;
      model.Token = token.access_token;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.AutomatedDrawingsEndPointServer;
      return this.http.post(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }

  saveAutomatedDrawing(automatedDrawing: AutomatedDrawing, id: string): Observable<AutomatedDrawing> {
    if (ApiEndPoints.UseDirectEndPoint) {
      let headers = this.authService.GetAuthHeader();
      let options = new RequestOptions({ headers: headers });
      const url = ApiEndPoints.AutomatedDrawingsEndPoint.replace('{accountId}', id);
      return this.http.put(url, automatedDrawing, options)
        // .do(data => console.log('updateUser: ' + JSON.stringify(data)))
        .catch(this.handleError);
    } else {
      let token = this.authService.getToken();
      let model = new AutomatedDrawingReportModel();
      //model.EndPointURL = ApiEndPoints.AutomatedDrawingsEndPoint;
      model.Token = token.access_token;
      model.AutomatedDrawing = automatedDrawing;
      model.AccountId = id;
      let body = JSON.stringify(model);
      //let headers: Headers = new Headers({
      //  'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.authService.GetHeader() });
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.AutomatedDrawingsEndPointSaveServer;
      return this.http.put(callURL, body, options)
        .map((response: Response) => <any>response.json())
        .catch(this.handleError);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/reports.service.ts